import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select2"]

  connect() {
    this.autoSubmitTargets.forEach(input => {
      input.addEventListener("change", () => this.element.requestSubmit())
    })

    $(this.select2Targets).each((_, elt) => {
      $(elt).on("change", () => this.element.requestSubmit())
    })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  debouncedSubmit() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 500)
  }

  get autoSubmitTargets() {
    return [
      ...this.element.querySelectorAll("input"),
      ...this.element.querySelectorAll("select"),
      ...this.element.querySelectorAll("textarea")
    ]
  }
}
